import { render, staticRenderFns } from "./AddBenefits.vue?vue&type=template&id=6321c0df"
import script from "./AddBenefits.vue?vue&type=script&lang=js"
export * from "./AddBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports